<template>
  <div>
    <Modal
      v-model="selectModal"
      title="选择凭证"
      width="1000">
      <div style="text-align: left">
        <RadioGroup v-model="selectType">
          <Radio label="standard">常规选择</Radio>
        </RadioGroup>
      </div>
      <Divider />
      <div>
        <span>已凭证(<b>{{ selectRow.length }}</b>)：<a v-on:click="emptySelect" v-if="selectRow.length">清空 </a> </span>
        <Tag color="primary" closable v-for="(item, index) in selectRow" :key="'name_' + index" @on-close="removeSelect('remove', item)">{{ item }}</Tag>
      </div>
      <Divider />
      <Form inline :label-width="60" ref="searchSelectForm" :model="searchSelectForm">
        <FormItem label="凭证名称">
          <Input v-model="searchSelectForm.name" @on-enter="getData()" placeholder="过滤凭证名称"/>
        </FormItem>
        <FormItem label="用户名" :label-width="50">
          <Input v-model="searchSelectForm.username" @on-enter="getData()" placeholder="过滤用户名"/>
        </FormItem>
        <FormItem :label-width="0" class="mob-align-right">
          <Button type="primary" @click="getData()" style="margin-right: 8px">搜索</Button>
          <Button @click="resetSelectSearchForm">重置</Button>
        </FormItem>
      </Form>
      <Alert v-if="dataError" type="warning" show-icon>获取凭证列表失败</Alert>
      <div v-else>
        <Table
          :loading="dataTableLoading"
          :data="tableData.data"
          size="small"
          :columns="tableData.columns">
        </Table>
        <div style="margin: 10px 0; overflow: hidden;">
          <div style="float: left;">
            当前显示 {{ tableData.data.length }} 条记录，总共 {{ tableData.count }} 条记录
          </div>
          <div style="float: right;">
            <page :total="tableData.count" :current="tableData.page" :page-size="tableData.size" @on-change="getData"></page>
          </div>
        </div>
      </div>
      <div slot="footer">
        <Button type="primary" style="margin-right: 8px" @click="selectOk">确定</Button>
        <Button @click="selectModal = false">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { getOpsCenterCertificate } from '@/api/opscenter'
export default {
  name: 'certificate-select-modal',
  data () {
    return {
      dataError: false,
      selectModal: false,
      selected: [],
      selectType: 'standard',
      searchSelectForm: {
        name: '',
        username: ''
      },
      fixedParams: {},
      tableData: {
        data: [],
        columns: [
          {
            title: '选中',
            align: 'center',
            minWidth: 60,
            key: 'checkBox',
            render: (h, params) => {
              let disabled = false
              if (!params.row.name) {
                disabled = true
              }
              let isCheck = false
              if (this.selectRow.indexOf(params.row.name) > -1) {
                isCheck = true
              }
              return h('div', [
                h('Checkbox', {
                  props: {
                    value: isCheck,
                    disabled: disabled
                  },
                  on: {
                    'on-change': (e) => {
                      this.server.data[params.index].checkBox = e
                      if (e) {
                        if (this.selectRow.indexOf(params.row.name) < 0) {
                          this.selectRow.push(params.row.name)
                          this.selectServerIds[params.row.name] = params.row.id
                        }
                      } else {
                        this.removeServer(null, params.row.name)
                      }
                    }
                  }
                })
              ])
            }
          },
          {
            title: '凭证名称',
            key: 'name',
            align: 'center',
            minWidth: 120
          },
          {
            title: '用户名',
            key: 'username',
            align: 'center',
            minWidth: 120
          },
          {
            title: '协议',
            key: 'protocol',
            align: 'center',
            minWidth: 150,
            render: (h, params) => {
              if (params.row.protocol) {
                return h('div', params.row.protocol.name)
              } else {
                return ''
              }
            }
          },
          {
            title: '端口',
            key: 'port',
            align: 'center',
            minWidth: 80
          }
        ],
        count: 0,
        page: 1,
        size: 5
      },
      dataTableLoading: false,
      selectRow: [],
      selectIds: {},
      endSelect: {},
      endSelectLength: 0,
      id: ''
    }
  },
  methods: {
    // 打开选择Modal
    openSelectModal (fixedParams = {}, selected = {}, id = '') {
      this.id = id
      this.fixedParams = fixedParams
      this.selectModal = true
      this.getData()
      this.selectIds = {}
      this.selectRow = []
      for (let name in selected) {
        if (selected[name]) {
          this.selectRow.push(name)
          this.selectIds[name] = selected[name]
        }
      }
    },
    // 获取列表
    getData (value = 1) {
      this.tableData.page = value
      this.dataTableLoading = true
      this.searchSelectForm['size'] = this.tableData.size
      this.searchSelectForm['page'] = this.tableData.page
      for (let p in this.fixedParams) {
        this.searchSelectForm[p] = this.fixedParams[p]
      }
      this.dataError = false
      getOpsCenterCertificate(this.searchSelectForm).then(res => {
        let result = res.data
        this.tableData.count = result.count
        this.tableData.data = result.results
        this.dataTableLoading = false
      }).catch(res => {
        this.dataError = true
        this.dataTableLoading = false
        if (res.request) {
          this.$Notice.error({
            title: '获取凭证列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    // 重置搜索表单
    resetSelectSearchForm () {
      this.searchSelectForm = {
        name: '',
        asset_type: '',
        asset_ip: ''
      }
      this.getData()
    },
    // 移除选中
    removeSelect (event, name) {
      if (event) {
        for (let i in this.tableData.data) {
          if (this.tableData.data[i].name === name) {
            this.tableData.data[i].checkBox = false
            break
          }
        }
      }
      const index = this.selectRow.indexOf(name)
      this.selectRow.splice(index, 1)
      this.selectIds[name] = null
    },
    // 清空选中
    emptySelect () {
      this.selectIds = {}
      for (let i in this.tableData.data) {
        this.tableData.data[i].checkBox = false
      }
      this.selectRow = []
    },
    // 选择完成
    selectOk () {
      this.endSelect = {}
      for (let name in this.selectIds) {
        if (this.selectIds[name]) {
          this.endSelect[name] = this.selectIds[name]
        }
      }
      this.selectIds = {}
      this.selectRow = []
      this.endSelectLength = Object.keys(this.endSelect).length
      this.selectModal = false
      this.$emit('selectComplete', this.endSelect, this.endSelectLength, this.id)
    }
  }
}
</script>

<style>
  .list-group-item {
    position: relative;
    display: block;
    padding: 10px 15px;
    margin-bottom: -1px;
    background-color: #fff;
    border: 1px solid #ddd;
  }
</style>
